(function () {'use strict';}());
angular.module("app").config(function($compileProvider){
		$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|sms|tel):/);
	}).directive('resourcesView', function($document,$timeout, $sce) {
    return {
      restrict: 'A',
      templateUrl: 'views/resources.html?version=1.0',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
        $scope.resources = __RESOURCES__.concat();
        $scope.resources.forEach(function(e){
        	e.TELLINK = $sce.trustAsHtml('tel:' + e.TELLINK);
        });

        $scope.isFirst = function(resource) {
          var city = resource.CITY;
          var cities = $scope.resources.filter(function(e){ return e.CITY === city; });
          var index = cities.indexOf(resource);
          return index === 0;
        };
      }  
    };
  });